import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sendConfirmation } from 'modules/auth/auth.actions';
import { showModal } from 'modules/navigation/navigation.actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import GetTokensModal from 'modules/getTokens/getTokensModal.component';
import { Image, LinkFont, HoverButton, Pressable } from 'modules/styled';

const twitterIcon = require('public/img/icons/twitter_white.png');
const redditIcon = require('public/img/icons/reddit.png');

const TwitterButton = () => (
  <Pressable to="/auth/twitter" external sx={{ mr: ['auto', 0], mt: 3 }}>
    <HoverButton
      sx={{
        width: ['auto', 22 * 8],
        bg: 'twitterBlue',
        m: 0,
      }}
    >
      <Image
        resizeMode="contain"
        source={twitterIcon}
        sx={{ width: 4, height: 4, mr: 1.5 * 8.001 }}
      />
      <LinkFont sx={{ color: 'white' }}>Connect Twitter</LinkFont>
    </HoverButton>
  </Pressable>
);

const RedditButton = () => (
  <Pressable to="/auth/reddit" external mr={['auto', 0]} mt={3}>
    <HoverButton
      sx={{
        width: ['auto', 22 * 8],
        bg: 'redditColor',
        m: 0,
      }}
      fdirection="row"
    >
      <Image
        resizeMode="contain"
        source={redditIcon}
        sx={{ width: 4, height: 4, mr: 1.5 * 8.001 }}
      />
      <LinkFont sx={{ color: 'white' }}>Connect Reddit</LinkFont>
    </HoverButton>
  </Pressable>
);

class GetTokensModalContainer extends Component {
  render() {
    return (
      <GetTokensModal
        {...this.props}
        twitterButton={<TwitterButton />}
        redditButton={<RedditButton />}
      />
    );
  }
}

GetTokensModalContainer.propTypes = {
  actions: PropTypes.object,
  close: PropTypes.func,
  auth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state?.auth || {},
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      // createInvite,
      // getInviteCount
      sendConfirmation,
      showModal,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetTokensModalContainer);
